/** Shown on every page while the product is a demo (DEMO_NOTICE, on by default). */
export function DemoNotice() {
  return (
    <div role="note" className="border-b border-line bg-surface px-4 py-1.5 text-center text-xs text-mid">
      <strong className="font-semibold text-ink">Demo</strong> · Not real insurance. Nothing here can be bought, and the people and businesses are made up.
    </div>
  );
}
